function closeModal(_modal, _backdrop) {
  const modal = _modal
  const backdrop = _backdrop
  backdrop.classList.add('fade-out-backdrop')
  modal.classList.remove('u-is-shown')
  setTimeout(() => {
    backdrop.classList.remove('fade-out-backdrop')
    backdrop.classList.remove('u-is-shown')

    document.body.classList.remove('u-no-overflow')
  }, 300)
}

export function openServiceModal() {
  const modalTriggers = [...document.querySelectorAll('.js-modal')]
  const modal = document.querySelector('.c-popup--service')
  const modalTitle = modal.querySelector('.c-popup__title')
  const backdrop = document.querySelector('.c-popup__backdrop')
  modalTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault()

      populateFormSubjectField(e.target.dataset.subject)
      const closeButton = document.querySelector('.c-icon--popup-close')
      modal.classList.add('u-is-shown')
      backdrop.classList.add('u-is-shown')
      document.body.classList.add('u-no-overflow')
      modalTitle.textContent = e.target.dataset.subject
      backdrop.addEventListener('click', () => {
        closeModal(modal, backdrop)
      })
      closeButton.addEventListener('click', () => {
        closeModal(modal, backdrop)
      })
      window.addEventListener('keyup', (e) => {
        if (e.keyCode == 27) {
          closeModal(modal, backdrop)
        }
      })
    })
  })
}

export function openCampaignModal() {
  const modalTriggers = [...document.querySelectorAll('.js-modal')]
  const modal = document.querySelector('.c-popup--campaign')
  const modalTitle = modal.querySelector('.c-popup__title')
  const backdrop = document.querySelector('.c-popup__backdrop')
  modalTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault()

      populateFormSubjectField(e.target.dataset.subject)
      const closeButton = document.querySelector('.c-icon--popup-close')
      modal.classList.add('u-is-shown')
      backdrop.classList.add('u-is-shown')
      document.body.classList.add('u-no-overflow')
      modalTitle.textContent = e.target.dataset.subject
      backdrop.addEventListener('click', () => {
        closeModal(modal, backdrop)
      })
      closeButton.addEventListener('click', () => {
        closeModal(modal, backdrop)
      })
      window.addEventListener('keyup', (e) => {
        if (e.keyCode == 27) {
          closeModal(modal, backdrop)
        }
      })
    })
  })
}

export function openApplyModal() {
  const postTitle = document.querySelector('.c-hero__title').textContent
  const modalTrigger = document.querySelector('.c-button--apply')
  const modal = document.querySelector('.c-popup--apply')
  const modalTitle = modal.querySelector('.c-popup__title')
  const backdrop = document.querySelector('.c-popup__backdrop')
  const hiddenField = modal.querySelector('.c-form-hidden-title input')

  modalTrigger.addEventListener('click', () => {
    const closeButton = modal.querySelector('.c-icon--popup-close')
    modal.classList.add('u-is-shown')
    backdrop.classList.add('u-is-shown')
    document.body.classList.add('u-no-overflow')
    hiddenField.value = postTitle
    backdrop.addEventListener('click', (e) => {
      closeModal(modal, backdrop)
    })
    closeButton.addEventListener('click', (e) => {
      closeModal(modal, backdrop)
    })
    window.addEventListener('keyup', (e) => {
      if (e.keyCode == 27) {
        closeModal(modal, backdrop)
      }
    })
  })
}

export function openMenu() {
  const burger = document.querySelector('.c-icon--hamburger')
  const menu = document.querySelector('.c-nav--mobile')

  burger.addEventListener('click', (e) => {
    e.preventDefault()
    menu.classList.add('u-no-translate')
    document.body.classList.add('u-no-overflow')
    const close = document.querySelector('.c-icon--nav')

    close.addEventListener('click', (e) => {
      menu.classList.remove('u-no-translate')
      document.body.classList.remove('u-no-overflow')
    })
  })
}

function populateFormSubjectField(input) {
  const inputField = document.querySelector('#input_10_3')
  const inputCampaignField = document.querySelector('#input_18_3')
  if (inputField) {
    inputField.value = input
  }

  if (inputCampaignField) {
    inputCampaignField.value = input
  }
}

export function openStickyCTA() {
  const button = document.querySelector('.c-button--cta')
  const popup = document.querySelector('.c-popup--cta')
  const active = 'c-button--cta-active'
  const hide = 'u-is-hidden'
  const stickyModalClose = popup.querySelector('.c-popup__close')

  if (button && popup) {
    stickyModalClose.addEventListener('click', (e) => {
      button.classList.remove(active)
      popup.classList.add(hide)
      e.stopPropagation()
    })
    button.addEventListener('click', (e) => {
      e.preventDefault()
      if (popup.classList.contains(hide)) {
        button.classList.add(active)
        popup.classList.remove(hide)
        e.stopPropagation()
      } else {
        button.classList.remove(active)
        popup.classList.add(hide)
        e.stopPropagation()
      }
    })
  }
}

export function openChangePasswordModal() {
  const modalTriggers = [...document.querySelectorAll('.js-modal')]
  const modal = document.querySelector('.c-popup--change-pw')
  const backdrop = document.querySelector('.c-popup__backdrop')
  modalTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault()

      const closeButton = document.querySelector('.c-icon--popup-close')
      modal.classList.add('u-is-shown')
      backdrop.classList.add('u-is-shown')
      document.body.classList.add('u-no-overflow')
      backdrop.addEventListener('click', () => {
        closeModal(modal, backdrop)
      })
      closeButton.addEventListener('click', () => {
        closeModal(modal, backdrop)
      })
      window.addEventListener('keyup', (e) => {
        if (e.keyCode == 27) {
          closeModal(modal, backdrop)
        }
      })
    })
  })
}
